import { del, get, patch, post } from "../../lib/fetch"
import type { CreateProviderInput, GetProvidersResponse, UpdateProviderInput  } from "@montatec/contracts"

export const providersService = {
    get:    async () => await get<GetProvidersResponse>(`/api/providers/providers`).then(res => res.data),
    create: async (data: CreateProviderInput) => await post(`/api/providers/providers`, data),
    update: async (id: number, data: UpdateProviderInput) => await patch(`/api/providers/providers/${id}`, data),
    delete: async (id: number) => await del(`/api/providers/providers/${id}`)
}